<template>
  <div class="product_introduction">
    <div class="banner">
      <div class="left">
        <div class="title_box">
          <div class="image-and-text">
            <img src="../../../assets/医疗管理 智慧一体.png" alt="图标" class="kelete">
          </div>
          <div style="margin-top: 20px;" class="small_title"> <img src="../../../assets/助力医疗诊所高效运转.png" alt="图标"
              class="kelete"> </div>
          <div style="margin-top: 20px;"><el-button type="primary">免费试用</el-button></div>
        </div>
      </div>
    </div>
    <div>
      <!-- 新增单元块 -->
      <div class="new-unit-block">
        <p>ALL IN ONE</p>
        <p>医疗行政一体化，高效管理全掌控</p>
      </div>
    </div>

    <div class="section-bg" :style="{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }">
      <transition name="animate__animated animate__bounce" appear enter-active-class="animate__fadeInDown">
        <div class="section-title">医疗端介绍</div>
      </transition>
      <transition name="animate__animated animate__bounce" appear enter-active-class="animate__fadeInDown">
      <div class="content-box bg-gray">
        <div class="flex-center"><img class="icon-small" src="@/assets/画板 16@2x.png" alt=""> 
          <span class="title-text">线上病历/电子处方</span>
        </div>
        <div class="description-text">患者每次就诊后，医生可将诊断结果、检查报告等信息录入系统，形成完整的电子病历，方便医生随时查阅患者的历史诊疗信息，
            为后续治疗提供参考</div>
        <div class="img-container"><img class="responsive-img" src="@/assets/WPS图片(1)@2x.png" alt=""></div>
      </div>
    </transition>
    </div>

    <div class="section-bg" :style="{ backgroundImage: `url(${bgImage1})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',padding: '50px' }">
      <div class="content-box bg-white">
        <transition name="animate__animated animate__bounce" appear enter-active-class="animate__fadeInLeft">   
          <div class="title-text-left">线上预约挂号</div>
        </transition>
        <div class="description-text">患者每次就诊后，医生可将诊断结果、检查报告等信息录入系统，形成完整的电子病历，方便医生随时查阅患者的历史诊疗信息，
            为后续治疗提供参考</div>

        <div class="flex-container">
          <div class="flex-item">
            <div class="flex-center">
              <img class="icon-small" src="@/assets/画板1.png" alt="">
              <span class="subtitle-text">网页端</span>
            </div>
            <img class="responsive-img web-img" src="@/assets/WPS图片3@2x.png" alt="">
          </div>
          <div class="flex-item">
            <div class="flex-center">
              <img class="icon-small" src="@/assets/画板17.png" alt="">
              <span class="subtitle-text">小程序</span>
            </div>
            <img class="responsive-img app-img" src="@/assets/组 6@2x.png" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="section-bg" :style="{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }">
      <transition name="animate__animated animate__bounce" appear enter-active-class="animate__fadeInDown">     
        <div class="flex-container card-container">
          <div class="card green-bg">
            <div class="flex-center">
              <img class="icon-small" src="@/assets/画板5@2x.png" alt="">
              <span class="title-text-card">药品进销存</span>
            </div>
            <div class="description-text">实时监控药品库存，自动提醒采购人员及时补充药品</div>
            <img class="responsive-img" src="@/assets/WPS图片4@2x.png" alt="">
          </div>
          <div class="card blue-bg">
            <div class="flex-center">
              <img class="icon-small" src="@/assets/画板4@2x.png" alt="">
              <span class="title-text-card">医师人才库</span>
            </div>
            <div class="description-text">提供全面、高效的专业医师人才招聘和管理服务</div>
            <img class="responsive-img" src="@/assets/WPS图片6@2x.png" alt="">
          </div>
        </div>
      </transition>
    </div>

    <div class="section-bg" :style="{ backgroundImage: `url(${bgImage3})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',padding: '30px' }">
      <transition name="animate__animated animate__bounce" appear enter-active-class="animate__fadeInDown">     
        <div class="content-box bg-lightblue">
          <div class="flex-center">
            <span class="title-text">专业理疗服务，提升患者康复体验</span>
          </div>
          <div class="description-text center-margin">患者每次就诊后，医生可将诊断结果、检查报告等信息录入系统，形成完整的电子病历，方便医生随时查阅患者的历史诊疗信息，
              为后续治疗提供参考</div>
          <div class="img-container"><img class="responsive-img radius" src="@/assets/WPS图片66@2x.png" alt=""></div>
        </div>
      </transition>
    </div>

    <div class="section-bg" :style="{ backgroundImage: `url(${bgImage4})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',padding: '30px' }">
      <transition name="animate__animated animate__bounce" appear enter-active-class="animate__fadeInDown">
        <div class="marketing-container">
          <div class="flex-container marketing-flex">
            <div class="marketing-card" :style="{ backgroundImage: `url(${bgImage5})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', borderRadius:'2%' }">
              <div>
                <div>
                  <span class="white-title">营销活动</span>
                </div>
                <div class="white-text">提供丰富的营销活动模板，如优惠券、打折促销、会员活动等，帮
                  助中医馆快速策划和实施各类营销活动</div>
                <img class="marketing-img" src="@/assets/9@2x.png" alt="">
              </div>
            </div>
            <div class="marketing-card" :style="{ backgroundImage: `url(${bgImage6})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', borderRadius:'2%' }">
              <div>
                <div>
                  <span class="white-title">营销统计</span>
                </div>
                <div class="white-text">系统会生成详细的营销数据分析报表，包
                  括活动参与人数、消费金额、转化率等指
                  标，帮助管理者了解营销活动的效果，及
                  时调整营销策略</div>
                <img class="stats-img" src="@/assets/组5247@2x.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="section-bg" :style="{ backgroundImage: `url(${bgImage7})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', padding: '30px' }">
      <div class="section-title white">不止这些，您可能还关心</div>
      <div class="feature-grid">
        <div v-for="(item, index) in list" :key="index" class="feature-item">
          <div class="feature-content">
            <div><img class="feature-icon" :src="item.img" alt=""></div>
            <div class="feature-text">
              <div class="feature-title">{{ item.title }}</div>
              <div class="feature-desc">{{ item.txt }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-bg" :style="{ backgroundImage: `url(${bgImage8})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', padding: '30px' }">
      <div class="section-title black">您可能还有疑问？</div>
      <div class="faq-container">
        <div v-for="(item, index) in dataList" :key="index" class="faq-item">
          <div class="faq-title">{{item.title}}</div>
          <div class="faq-text">{{item.txt}}</div>
        </div>
        <div class="footer-title">克里特·易康，众多医疗诊所的好管家</div>
        <div class="footer-logo"><img src="@/assets/组14@2x.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList:[
        {title:'克里特·易康医疗管理系统对哪些诊所适用呢？',txt:'适用于西医、中医、全科、口腔、眼视光、儿科、医美等各类型诊所，同时也适用于中小个体诊所、大型诊所、连锁诊所、社区医院等多种规模的医疗机构。界面友好，轻松上手，功能强大。'},
        {title:'这个产品对我诊所里哪些角色适用呢？',txt:'克里特·易康医疗管理系统为诊所所有角色提供全面支持：患者便捷挂号，医生快速书写病历处方，护士高效执行医嘱，检验人员顺畅安排化验，药房人员轻松管理药品进销存，管理者实时掌握经营数据，营销人员轻松策划活动。'},
        {title:'安装方便吗？',txt:'安装克里特·易康医疗管理系统就像安装手机App一样简单。作为全新一代的基层医疗系统，您无需购买服务器，不用聘请技术人员，也不用经历繁琐的安装过程，只需在线注册，即可快速开始使用。另外我们也有小程序可以操作，非常方便。'},
        {title:'系统会持续更新吗？如果我有新需求怎么支持呢？',txt:'不同于传统软件一次性安装的方式，克里特·易康医疗管理系统是自动持续更新，无需手动操作。我们会通过各种渠道倾听诊所需求，提出切实解决问题的方案，确保用户问题即时解决。'},
      ],
      list:[
        {title:'排班管理',txt:'先进的算法优化医师排班，确保患者得到及时的诊疗服务。',img:require('@/assets/减去13@2x.png')},
        {title:'收银管理',txt:'自动计算费用，支持多种支付方式以及清晰的收银记录',img:require('@/assets/减去14@2x.png')},
        {title:'智能药房',txt:'快速发放药品，根据处方自动配药一键打印处方和药品信息',img:require('@/assets/减去15@2x.png')},
        {title:'随访管理',txt:'记录随访内容，设置随访计划，自动提醒随访',img:require('@/assets/减去17@2x.png')},
        {title:'线上咨询',txt:'记录咨询内容，自动标记咨询状态记录患者的健康信息',img:require('@/assets/减去18@2x.png')},
        {title:'科室管理',txt:'集中管理科室信息，快速检索，多种条件筛选。',img:require('@/assets/减去16@2x.png')}
      ],
      scrollPosition: 0,
      // 动态加载图片
      bgImage: require('@/assets/ylBg.png'),
      bgImage1: require('@/assets/ylBg1.png'),
      bgImage2: require('@/assets/ylBj2.png'),
      bgImage3: require('@/assets/组5394@2x.png'),
      bgImage4: require('@/assets/组5393@2x.png'),
      bgImage5: require('@/assets/矩形895@2x.png'),
      bgImage6: require('@/assets/矩形896@2x.png'),
      bgImage7: require('@/assets/组10@2x.png'),
      bgImage8: require('@/assets/组13@2x.png'),
    };
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.scrollPosition = window.scrollY;
    });
  }
};
</script>

<style lang="scss" scoped>
.product_introduction {
  width: 100%;
  overflow-x: hidden;
  
  .banner {
    width: 100%;
    height: 20rem;
    background-image: url('../../../assets/yilBanner.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 46%;
      height: 70%;
      padding-left: 2.8rem;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .title_box {
        height: 4.1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        display: flex;

        .image-and-text {
          display: flex;
          align-items: center;
        }

        .kelete {
          width: 60%;
          margin-top: 4px;
        }

        .big_title {
          font-weight: 600;
          font-size: 1.6rem;
          color: #000000;
        }

        .small_title {
          font-weight: 500;
          font-size: 0.82rem;
          color: #000000;
        }
      }
    }
  }

  // 新增单元块样式
  .new-unit-block {
    font-family: 'Source Han Sans CN', 'Source Han Sans CN';
    font-weight: 500;
    font-size: 32px;
    color: #252E3E;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 20px;
    padding: 0 15px;
  }
  
  .section-bg {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .section-title {
    padding-top: 50px;
    font-family: 'Source Han Sans CN', 'Source Han Sans CN';
    font-weight: 500;
    font-size: 32px;
    color: #252E3E;
    text-align: center;
    font-style: normal;
    text-transform: none;
    
    &.white {
      color: #FFFFFF;
    }
    
    &.black {
      color: #000;
    }
  }
  
  .content-box {
    margin: 30px auto;
    padding: 20px;
    width: 90%;
    max-width: 800px;
    border-radius: 8px;
    box-sizing: border-box;
    
    &.bg-gray {
      background: #F3F4F5;
    }
    
    &.bg-white {
      background: #fff;
    }
    
    &.bg-lightblue {
      background: #DFF6FA;
    }
  }
  
  .flex-center {
    display: flex;
    align-items: center;
  }
  
  .icon-small {
    height: 31px;
  }
  
  .title-text {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #252E3E;
    margin-left: 20px;
  }
  
  .title-text-left {
    font-family: 'Source Han Sans CN', 'Source Han Sans CN';
    font-weight: 500;
    font-size: 24px;
    color: #252E3E;
    text-align: left;
  }
  
  .title-text-card {
    font-weight: bold;
    font-size: 24px;
    color: #252E3E;
    margin-left: 10px;
  }
  
  .subtitle-text {
    font-weight: bold;
    font-size: 18px;
    color: #252E3E;
    margin-left: 10px;
  }
  
  .description-text {
    margin-top: 11px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #7D828D;
    line-height: 1.5;
    
    &.center-margin {
      margin-left: 20px;
    }
  }
  
  .img-container {
    margin-top: 15px;
    text-align: center;
  }
  
  .responsive-img {
    max-width: 100%;
    height: auto;
    
    &.radius {
      border-radius: 8px;
    }
  }
  
  .flex-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
  }
  
  .flex-item {
    flex: 1;
    margin: 10px;
  }
  
  .web-img {
    height: auto;
    max-width: 100%;
  }
  
  .app-img {
    height: auto;
    max-width: 170px;
    display: block;
    margin: 10px auto;
  }
  
  .card-container {
    padding: 30px 15px;
    justify-content: center;
  }
  
  .card {
    flex: 1;
    min-width: 250px;
    max-width: 450px;
    padding: 20px;
    border-radius: 8px;
    margin: 10px;
    box-sizing: border-box;
    
    &.green-bg {
      background: rgb(233, 251, 232);
    }
    
    &.blue-bg {
      background: #E2F2FF;
    }
  }
  
  .marketing-container {
    margin: 30px auto;
    width: 90%;
    max-width: 900px;
  }
  
  .marketing-flex {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
  }
  
  .marketing-card {
    flex: 0 0 48%;
    padding: 30px 30px 0px 30px;
    margin: 10px 0;
    min-width: 250px;
    box-sizing: border-box;
  }
  
  .white-title {
    font-weight: bold;
    font-size: 23px;
    color: #fff;
    margin-left: 10px;
    display: block;
    margin-bottom: 10px;
  }
  
  .white-text {
    margin-top: 11px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    line-height: 1.5;
  }
  
  .marketing-img {
    max-width: 100%;
    height: auto;
    margin-top: 15px;
  }
  
  .stats-img {
    height: auto;
    max-width: 100%;
    margin-top: 15px;
    display: block;
  }
  
  .feature-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 30px auto;
    width: 90%;
    max-width: 1000px;
  }
  
  .feature-item {
    width: calc(50% - 20px);
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    margin: 10px;
    box-sizing: border-box;
  }
  
  .feature-content {
    display: flex;
    align-items: center;
    padding-top: 10px;
  }
  
  .feature-icon {
    height: 34px;
    margin-right: 10px;
  }
  
  .feature-text {
    margin-left: 4px;
  }
  
  .feature-title {
    font-weight: 500;
    font-size: 16px;
    color: #252E3E;
  }
  
  .feature-desc {
    font-weight: 400;
    font-size: 12px;
    color: #A7ABB4;
    margin-top: 5px;
  }
  
  .faq-container {
    margin: 30px auto;
    width: 90%;
    max-width: 800px;
  }
  
  .faq-item {
    border: 1px solid #eee;
    padding: 20px;
    margin-top: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
  }
  
  .faq-title {
    font-weight: 500;
    font-size: 20px;
    color: #252E3E;
  }
  
  .faq-text {
    font-weight: 400;
    font-size: 14px;
    color: #7D828D;
    margin-top: 14px;
    line-height: 1.5;
  }
  
  .footer-title {
    text-align: center;
    font-weight: 500;
    font-size: 24px;
    color: #252E3E;
    margin-top: 36px;
  }
  
  .footer-logo {
    text-align: center;
    margin-top: 36px;
    
    img {
      width: 99px;
      height: auto;
    }
  }
  
  // 媒体查询 - 移动端适配
  @media screen and (max-width: 768px) {
     .feature-title {
      font-size: 12px !important;
    }
    
    .feature-desc {
      font-size: 9px  !important;
    }
    .product_introduction {
      .banner {
        height: 12rem;
        background-position: center;
        .left {
          padding: 0 20px;
          width: 100%;
          text-align: left;
        }
      }

      .new-unit-block {
        padding: 20px 15px;
        .section-title {
          font-size: 1.2rem;
          margin-bottom: 15px;
        }
        .content-box {
          font-size: 0.9rem;
          line-height: 1.6;
        }
      }

      .flex-container {
        padding: 15px;
        .flex-item {
          width: 100%;
          margin-bottom: 15px;
          padding: 15px;
          .title {
            font-size: 1.1rem;
            margin-bottom: 10px;
          }
          .content {
            font-size: 0.9rem;
            line-height: 1.5;
          }
        }
      }

      .marketing-flex {
        flex-direction: column;
        .marketing-card {
          flex: 0 0 100%;
          width: 100%;
          margin-bottom: 20px;
        }
      }

      .title_box {
        padding: 20px 15px;
        text-align: left;
        .image-and-text {
          margin-bottom: 15px;
        }
        .small_title {
          margin: 15px 0;
        }
      }
    }
  }
  
  @media screen and (max-width: 480px) {
    .banner {
      height: 12rem;
      
      .left .title_box {
        height: auto;
        
        .small_title {
          margin-top: 10px !important;
        }
      }
    }
    
    .new-unit-block {
      font-size: 20px;
    }
    
    .section-title {
      font-size: 20px;
      padding-top: 20px;
    }
    
    .title-text, .title-text-left, .title-text-card {
      font-size: 18px;
    }
    
    .subtitle-text {
      font-size: 16px;
    }
    
    .description-text {
      font-size: 12px;
    }
    
    .white-title {
      font-size: 18px;
    }
    
    .white-text {
      font-size: 12px;
    }
    
    .footer-title {
      font-size: 20px;
    }
    
    .card {
      padding: 15px;
    }
    
    .faq-item {
      padding: 15px;
    }
    
    .faq-title {
      font-size: 18px;
    }
    
    .faq-text {
      font-size: 13px;
    }
  }
  
  // 解决移动端歪斜问题的核心样式
  @media screen and (max-width: 768px) {
    .section-bg[style*="backgroundImage"] {
      background-position: center !important;
      width: 100% !important;
      left: 0 !important;
      right: 0 !important;
      box-sizing: border-box !important;
    }
    
    .marketing-card[style*="backgroundImage"] {
      background-position: center !important;
    }
    
    .flex-center {
      justify-content: center;
    }
    
    .description-text.center-margin {
      margin-left: 0;
      text-align: center;
    }
    
    .title-text-left {
      text-align: center;
    }
  }
}
</style>